const translations = {
  "hero": {
    "h1_line1": "Itaobuy",
    "h1_line2": "Spreadsheet",
    "h1_line3": "System",
    "subtitle": "A powerful spreadsheet-based sourcing system designed for e-commerce sellers, dropshippers, and import businesses to find, organize, and scale winning products efficiently.",
    "cta_access": "Access ItaobuySpreadsheet Tool",
    "cta_demo": "View Live Spreadsheet Demo"
  },
  "nav": {
    "home": "Home",
    "categories": "Categories",
    "buy_now": "buy it now",
    "itaobuy_sheet": "itaobuy sheet",
    "blog": "Blog",
    "shopping_guide": "Shopping Guide"
  },
  "value": {
    "label": "Why Choose Us",
    "title": "Powerful Sourcing Spreadsheet System",
    "subtitle": "ItaobuySpreadsheet replaces messy manual tracking with a structured, data-driven spreadsheet system.",
    "benefits": [
      "Track thousands of products in one place",
      "Compare suppliers instantly",
      "Identify winning products faster",
      "Reduce sourcing time by up to 70%",
      "Scale your e-commerce business efficiently"
    ]
  },
  "features": {
    "label": "Key Benefits",
    "title_line1": "Smart Features for",
    "title_line2": "Smarter Sourcing",
    "subtitle": "Everything you need to streamline your product sourcing workflow.",
    "cards": [
      {
        "title": "Smart Spreadsheet Structure",
        "desc": "Organized sourcing workflow with pre-built comparison fields to evaluate pricing, suppliers, and demand at a glance."
      },
      {
        "title": "Supplier Comparison System",
        "desc": "Built-in comparison tools help you make better profit decisions by analyzing multiple suppliers side by side."
      },
      {
        "title": "Automation Friendly Format",
        "desc": "Saves time and reduces errors with a format designed for easy integration with your existing e-commerce tools."
      }
    ],
    "blog_cta": "Read Sourcing Guide →"
  },
  "how_it_works": {
    "label": "How It Works",
    "title": "Three Simple Steps to Transform Your Sourcing",
    "steps": [
      {
        "number": "01",
        "title": "Collect Product Data",
        "desc": "Import product listings into the spreadsheet system with structured fields for easy organization."
      },
      {
        "number": "02",
        "title": "Analyze & Compare",
        "desc": "Use built-in comparison fields to evaluate pricing, suppliers, and market demand across products."
      },
      {
        "number": "03",
        "title": "Optimize & Scale",
        "desc": "Focus only on high-performing products and scale your business profitably with data-driven decisions."
      }
    ]
  },
  "about": {
    "label": "About Itaobuy Sheet",
    "title_line1": "The Ultimate",
    "title_line2": "Product Sourcing",
    "title_line3": "Spreadsheet Tool",
    "description": "ItaobuySpreadsheet is an advanced product sourcing framework designed for modern e-commerce entrepreneurs. We built this system to eliminate the chaos of manual tracking and replace it with a clean, structured approach that lets you focus on what matters — growing your business.",
    "quote": "ItaobuySpreadsheet completely transformed how I manage product sourcing. I went from messy spreadsheets to a clear, scalable system that saves me hours every week.",
    "author": "Marcus Chen",
    "role": "E-commerce Entrepreneur",
    "stat": "Trusted by 10K+ Sellers",
    "cta": "itaobuy sheet →"
  },
  "testimonials": {
    "label": "Seller Reviews",
    "title_line1": "Trusted by Dropshippers",
    "title_line2": "Worldwide",
    "subtitle": "What real sellers say about their experience with ItaobuySpreadsheet.",
    "reviews": [
      {
        "name": "Sarah Mitchell",
        "role": "Shopify Store Owner",
        "title": "Saved me 20+ hours per week",
        "body": "Before ItaobuySpreadsheet, I was drowning in product research. Now everything is organized in one place. The comparison system alone is worth it — I can spot winning products in minutes instead of hours.",
        "rating": 5
      },
      {
        "name": "David Park",
        "role": "Amazon FBA Seller",
        "title": "My profit margins improved significantly",
        "body": "The supplier comparison feature helped me negotiate better prices. Within the first month, I identified three suppliers I would have missed otherwise. Genuinely a game-changer for my business.",
        "rating": 5
      },
      {
        "name": "Emma Rodriguez",
        "role": "Dropshipping Entrepreneur",
        "title": "Finally, a system that makes sense",
        "body": "I've tried dozens of sourcing tools and spreadsheets. ItaobuySpreadsheet is the first one that actually fits my workflow instead of forcing me to adapt. Clean, logical, and incredibly efficient.",
        "rating": 5
      },
      {
        "name": "James Turner",
        "role": "E-commerce Consultant",
        "title": "I recommend it to all my clients",
        "body": "As someone who helps sellers scale their operations, ItaobuySpreadsheet is my go-to recommendation. The structured approach eliminates the learning curve most new sellers struggle with.",
        "rating": 5
      },
      {
        "name": "Lisa Wang",
        "role": "Multi-Platform Seller",
        "title": "Scaling became so much easier",
        "body": "Managing products across eBay, Amazon, and Shopify was a nightmare until I found this system. The spreadsheet-based approach means I can customize it exactly how I need.",
        "rating": 5
      },
      {
        "name": "Tom Bradford",
        "role": "Import Business Owner",
        "title": "Streamlined my entire supply chain",
        "body": "The organized layout helps me track everything from initial contact to final delivery. No more lost information or forgotten follow-ups. It's become essential to my daily operations.",
        "rating": 5
      }
    ]
  },
  "cta_section": {
    "title": "START SOURCING SMARTER",
    "subtitle_line1": "Join thousands of sellers using Itaobuy Sheet",
    "subtitle_line2": "to scale their business profitably.",
    "button": "GET ITAOBUY SHEET NOW"
  },
  "footer": {
    "brand": "itaobuy",
    "description": "The smartest product sourcing spreadsheet system for e-commerce sellers, dropshippers, and import businesses worldwide.",
    "address_line1": "123 Commerce Street",
    "address_line2": "Suite 456, Business District",
    "phone": "+1 (555) 123-4567",
    "email": "hello@itaobuy.boats",
    "copyright": "© 2026 itaobuy.boats. All rights reserved.",
    "links": {
      "privacy": "Privacy",
      "terms": "Terms",
      "back_home": "Back to Home"
    }
  },
  "blog_preview": {
    "title": "ItaobuySpreadsheet Guides & Resources",
    "subtitle": "Expert guides, comparisons, and tutorials to help you master product sourcing with ItaobuySpreadsheet. Discover tips for dropshipping, supplier management, and scaling your e-commerce business.",
    "article_title": "What Is ItaobuySpreadsheet? The Ultimate Product Sourcing System (2026 Guide)",
    "article_excerpt": "Discover how ItaobuySpreadsheet helps e-commerce sellers streamline product research, compare suppliers, and scale their business with a structured, data-driven spreadsheet system.",
    "read_more": "Read Full Guide →",
    "view_all": "View All Shopping Guides →"
  }
};

export default translations;